/*eslint-disable*/
import api from '../'

class whoIsWhoApi {
    // POST: whoIsWho
    static getCouplesByRequest (params) {
        return api.axios.post('/whoIsWhoCouplesByRequest', params).then(response => response.data.couples);
    }
}

export default whoIsWhoApi;
